import moment from "moment";
import { momentCierre } from "./horaCierre";

/**
 * El plazo para subsanar es su propia ventana dentro del cronograma de la
 * convocatoria, posterior al cierre; no coincide con la fecha de cierre. La
 * clave es la misma que valida el modal de subsanación al guardar, así que vive
 * aquí para que el panel, el aviso y esa validación no puedan discrepar.
 *
 * Esto es para la pantalla, no es un control de seguridad: el reloj que decide
 * es el del servidor al guardar. Aquí solo se evita llevar al participante a una
 * acción que ya no puede completar.
 */
export const PLAZO_SUBSANAR_CLAVE =
  "Plazo para subsanar documentos y presentar observaciones";

/** Fin del plazo de subsanación (con hora real) del cronograma; null si no hay dato. */
export const finPlazoSubsanar = (convocatoriaOItem: any): moment.Moment | null => {
  const fechas: any[] = Array.isArray(convocatoriaOItem?.fechas)
    ? convocatoriaOItem.fechas
    : [];
  const plazo = fechas.find((f: any) => f?.clave === PLAZO_SUBSANAR_CLAVE);
  if (!plazo?.valormax) return null;
  const fin = momentCierre(plazo.valormax);
  return fin.isValid() ? fin : null;
};

/**
 * El plazo para subsanar ya venció: hay fecha en el cronograma y quedó atrás.
 * Sin ese dato devuelve false (no bloquea nada desde el front).
 */
export const plazoSubsanarVencido = (
  convocatoriaOItem: any,
  ahora: moment.Moment = moment()
): boolean => {
  const fin = finPlazoSubsanar(convocatoriaOItem);
  return !!fin && ahora.isAfter(fin);
};
